export const AUS_FOODS_ID = "42";
export const AUS_BRANDS_ID = ["35", "35-1", "35-2", "35-3"];

// TODO: Make this a database setting
export const ENABLED_DATA_SOURCES = [AUS_FOODS_ID, ...AUS_BRANDS_ID];
